class CategoryCardGrid extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    if (this.dataset.carousel !== 'true') return;

    this.swiperEl = this.querySelector('.ccg__swiper');
    this.slides = this.querySelectorAll('.ccg__slide');
    if (!this.swiperEl || this.slides.length === 0) return;

    this.waitFor(
      () => window.Swiper,
      () => this.init()
    );
  }

  init() {
    const gap = parseInt(this.dataset.gap, 10) || 16;
    const desktopSlides = parseFloat(this.dataset.slidesDesktop) || 5;
    const tabletSlides = parseFloat(this.dataset.slidesTablet) || 3;
    const mobileSlides = parseFloat(this.dataset.slidesMobile) || 1.4;

    this.swiper = new window.Swiper(this.swiperEl, {
      slidesPerView: mobileSlides,
      spaceBetween: gap,
      speed: 450,
      watchOverflow: true,
      a11y: { enabled: true },
      keyboard: { enabled: true },
      navigation: {
        prevEl: this.querySelector('.ccg__arrow--prev'),
        nextEl: this.querySelector('.ccg__arrow--next'),
        disabledClass: 'swiper-button-disabled'
      },
      breakpoints: {
        750: { slidesPerView: tabletSlides },
        990: { slidesPerView: desktopSlides }
      }
    });
  }

  waitFor(check, callback, attempts) {
    const count = attempts || 0;
    if (check()) return callback();
    if (count > 100) return;
    setTimeout(() => this.waitFor(check, callback, count + 1), 50);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.initialized = false;
  }
}

if (!customElements.get('category-card-grid')) {
  customElements.define('category-card-grid', CategoryCardGrid);
}
